module.exports = __webpack_public_path__ + "static/media/camera.32995483.jpg";